import StepManager from "./components/StepManager";
import SlidingGallery from "./components/SlidingGallery";

import GoogleAds from "./scripts/GoogleAds";
import ExoclickScript from "./scripts/Exoclick";
import TrafficStarsScript from "./scripts/TrafficStars";
import TrafficJunkyScript from "./scripts/TrafficJunky";

import { urlParams } from "./store/UrlParameters";

import posthog from "posthog-js";

function App() {
  posthog.init("phc_vXs6F6PqVPJzdwj0cXw027waWElaJ3hO2k7hubXwuH5", {
    api_host: "https://eu.i.posthog.com",
    person_profiles: "identified_only",
    autocapture: false,
  });

  posthog.setPersonProperties({
    campaign: urlParams().cmp_id || "empty",
    landing: urlParams().lp_id || "empty",
    offer: urlParams().offer_id || "empty",
  });

  return (
    <div class="m-auto flex h-full w-full max-w-xl flex-col space-y-2 px-2 py-2">
      <div class="relative flex h-full flex-col justify-end space-y-4 overflow-hidden rounded-2xl border-2 py-4 text-white shadow-lg">
        <StepManager></StepManager>
      </div>
      <SlidingGallery></SlidingGallery>
      <GoogleAds />
      <ExoclickScript />
      <TrafficJunkyScript />
      <TrafficStarsScript />
    </div>
  );
}

export default App;
